import { render, staticRenderFns } from "./OrdenCompraCrud.vue?vue&type=template&id=5e32b402&"
import script from "./OrdenCompraCrud.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports